export interface RouteOption {
  label: string;
  path: string;
}

export const routeOptions: RouteOption[] = [
    { label: 'Home', path: '/home' },
    { label: 'MIGOP', path: '/michigangop' },
    { label: 'State Party', path: '/stateparty' },
    { label: 'Delegate', path: '/delegate' },
    { label: 'State Convention', path: '/stateconvention' },
    { label: 'County Convention', path: '/countyconvention' },
    { label: 'Timeline', path: '/timeline' },
    { label: 'Documents', path: '/documents' },
    { label: 'RONR for Delegates', path: '/roberts' }
  ];